import { Button } from "@/ds/shadcn/components/ui/button";
import { Progress } from "@/ds/shadcn/components/ui/progress";
import { cn } from "@/ds/utils";
import { PlusIcon } from "lucide-react";
import type { FC } from "react";

export interface ProgressBarWithButtonProps {
	current: number;
	max: number;
	onClick: () => void;
	className?: string;
}

export const ProgressBarWithButton: FC<ProgressBarWithButtonProps> = props => {
	const {
		current,
		max,
		onClick,
		className
	} = props;

	const percentage = max > 0 ? 100 * Math.min(current / max, 1) : 0;

	return (
		<div className={cn("flex items-center gap-2", className)}>
			<Progress value={percentage} />
			<Button
				variant="ghost"
				size="icon"
				className="h-6 w-6 shrink-0"
				onClick={e => {
					e.stopPropagation();
					onClick();
				}}>
				<PlusIcon />
			</Button>
		</div>
	);
};
